import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

function SuperuserRoute() {
  const { userData, loading } = useAuth();

  if (loading) {
    return <div className="form-container"><p>Cargando...</p></div>;
  }

  if (!userData || !['superuser', 'masteruser'].includes(userData.rol)) {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
}

export default SuperuserRoute;
